/* RESPONSIBLE TEAM: team-proactive-support */
import BaseAboutRoute from 'embercom/routes/base/about-route';

export default BaseAboutRoute.extend();
